import { render, staticRenderFns } from "./tagsview.vue?vue&type=template&id=3010bbf4&"
import script from "./tagsview.vue?vue&type=script&lang=js&"
export * from "./tagsview.vue?vue&type=script&lang=js&"
import style0 from "./tagsview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports